import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-fb-share',
  templateUrl: './fb-share.component.html',
  styleUrls: ['./fb-share.component.scss']
})
export class FbShareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
